import {Icon24Back, Icon24CheckCircleOutline} from "@vkontakte/icons";
import {Button, Div} from "@vkontakte/vkui";
import React from "react";
import * as constants from "./constants";

import ReactDOM from 'react-dom';

class KBInput extends React.Component {

    state = {
        value: '',
        numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
        showKeyboard: false,
        onBottom: false,
        onRight: false
    }

    constructor(props) {
        super(props);

        this.guid = constants.getGUID()
        this.ref = React.createRef()
        this.refBtn = React.createRef()
        if (this.props.value) {
            this.state.value = this.props.value
        }
    }

    checkScroll() {

        if (!this.ref.current) return
        this.currentTop = this.ref.current.getBoundingClientRect().bottom
        this.currentLeft = this.ref.current.getBoundingClientRect().left
    }

    receiveMessage = (event) => {

        if (event.data.type != undefined) {
            if (event.data.type == "openKBInput" && event.data.guid != this.guid) {
                this.setState({showKeyboard: false})
            }

            if (event.data.type == "openKBInputById" && event.data.uid == this.props.uid) {
               this.showKB()
            }
        }
    }
    handleScroll = () => {
        this.checkScroll()
    }

    componentDidMount() {
        window.addEventListener("message", this.receiveMessage, false)
        window.addEventListener('scroll', this.handleScroll);
        setTimeout(() => this.checkScroll(), 200)
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.value != this.props.value) {
            this.setState({value: this.props.value})
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener("message", this.receiveMessage)
    }

    render() {

        const keyboard =
            ReactDOM.createPortal(
                <div key={"input-kb-numbers"+this.guid} style={
                    {top: `${this.currentTop + window.scrollY}px`,
                        left: this.state.onRight?`${this.currentLeft + window.scrollX - 250}px`:`${this.currentLeft}px`,
                    }}
            className={"KBInput-wrapper" + (this.state.onBottom ? " on-bottom" : '') + (this.state.onRight ? " on-right" : '')}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation()
            }}>

            <Div className={"KBInput-digits"}>
                {this.state.numbers.map((el, index) => {
                    return (
                        <Button key={"input-kb-num"+el+this.guid} size="l" mode="outline" stretched={el == 0} onClick={(e) => {
                            e.stopPropagation();
                            this.addToValue(el)
                        }}>{el}</Button>
                    )
                })}
                <Button key={"input-bcksp-"+this.guid} size="l" mode="outline" stretched onClick={(e) => {
                    e.stopPropagation();
                    this.backSpace()
                }}><Icon24Back/></Button>
                <Button key={"input-ok-"+this.guid} size="l" mode="outline" stretched onClick={(e) => {
                    e.stopPropagation();
                    this.setState({showKeyboard: false})
                }}><Icon24CheckCircleOutline/></Button>
            </Div>

        </div>, document.body)

        return (
            <div ref={this.ref} className="KBInput" key={"input-kb-"+this.guid}>
                <Div className={"KBInput-btn " + (this.state.showKeyboard ? 'active' : '')} ref={this.refBtn}
                     style={{...this.props.style}} size="l"

                     onClick={(e) => {
                         e.stopPropagation()
                         this.showKB()
                     }}

                >{this.state.value}</Div>
                {this.state.showKeyboard&& keyboard}

            </div>
        )
    }

    showKB = () =>{
        if (this.props.readonly && this.props.readonlyError) {
            this.props.readonlyError()
        }

        if (this.props.readonly) return
        const onBottom = this.currentTop  + 270 > window.innerHeight;
        const onRight = this.currentLeft + 250 > window.innerWidth;
        console.log(this.currentTop, window.scrollY, window.innerHeight)

        window.postMessage({type: 'openKBInput', guid: this.guid})
        this.setState({showKeyboard: !this.state.showKeyboard, onBottom, onRight})
    }
    backSpace = () => {
        let old = this.state.value.toString()
        old = old.substring(0, old.length - 1)
        this.setState({value: old == '' ? '0' : old})
        if (this.props.onChange) {
            this.props.onChange(old)
        }
    }
    addToValue = (el) => {
        let old = this.state.value
        if (old.length > 6) return
        if (old == '0') old = ''
        old += el
        this.setState({value: old})
        if (this.props.onChange) {
            this.props.onChange(old)
        }
    }
}

export default KBInput